<template>
  <div class="container">
    <div v-if="$route.query.id" class="header">编辑素材</div>
    <div v-else class="header">新建素材</div>
    <div class="main">
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="10.0rem">
        <div class="form-header">
          <el-form-item prop="title" label="标题：">
            <el-input
              clearable
              style="width: 30%"
              v-model="form.title"
              placeholder="请输入标题"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-content">
          <el-form-item prop="type" label="内容类型：">
            <el-radio-group v-model="form.type" @change="changeType">
              <el-radio label="文本">文本</el-radio>
              <el-radio label="图片">图片</el-radio>
              <el-radio label="视频">视频</el-radio>
              <el-radio label="文件">文件</el-radio>
              <el-radio label="链接">链接</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="link" v-if="form.type === '链接'" label="链接：">
            <el-input
              clearable
              style="width: 30%"
              v-model="form.link"
              placeholder="链接必须带有http或https协议，如：https://work.weijub.com"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="linkTitle"
            v-if="form.type === '链接'"
            label="标题："
          >
            <el-input
              clearable
              style="width: 30%"
              v-model="form.linkTitle"
              placeholder="请输入链接标题"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="file"
            v-if="
              form.type === '链接' ||
              form.type === '文件' ||
              form.type === '视频' ||
              form.type === '图片'
            "
            :label="form.type === '链接' ? '封面' : form.type + '：'"
          >
            <el-upload
              style="width: 30%"
              class="upload-demo"
              :action="
                this.axios.defaults.baseURL +
                '/api/Alioss/upload_temp_uploadimg'
              "
              :data="upParams"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-upload="handleBeforeUpload"
              :on-success="handleSuccess"
              :on-error="handleError"
              :before-remove="beforeRemove"
              :on-exceed="handleExceed"
              :file-list="fileList"
              :list-type="listType"
              :accept="accept"
              :limit="1"
            >
              <el-button type="primary" icon="el-icon-upload">
                上传{{ form.type === "链接" ? "封面" : form.type }}
              </el-button>

              <div slot="tip" class="el-upload__tip">{{ tip }}</div>
            </el-upload>
          </el-form-item>
          <el-form-item v-if="isShowVideo" label="">
            <div>
              <video
                style="width: 224px; height: 126px"
                :src="form.file"
                controls="controls"
              ></video>
            </div>
          </el-form-item>
          <el-form-item
            prop="desc"
            v-if="form.type === '链接' || form.type === '文本'"
            label="内容："
          >
            <el-input
              clearable
              style="width: 30%"
              type="textarea"
              autosize="true"
              v-model="form.desc"
              placeholder="请输入内容"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-footer">
          <el-form-item label-width="0">
            <el-button type="primary" @click="submitForm('ruleForm')"
              >立即创建</el-button
            >
            <el-button
              style="margin-left: 2.0rem"
              type=""
              plain
              @click="$router.back()"
              >取消</el-button
            >
          </el-form-item>
        </div>
      </el-form>
    </div>
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="[url]"
    />
  </div>
</template>
<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import axios from "axios";
import qs from "qs";
export default {
  components: { ElImageViewer },
  data() {
    return {
      form: {
        title: "",
        type: "",
        desc: "",
        file: "",
        link: "",
        linkTitle: "",
        linkCover: "",
        media_id: "",
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
        desc: [{ required: true, message: "请输入内容", trigger: "blur" }],
        file: [{ required: true, message: "请选择文件", trigger: "blur" }],
        link: [{ required: true, message: "请输入链接", trigger: "blur" }],
        linkTitle: [
          { required: true, message: "请输入链接标题", trigger: "blur" },
        ],
        linkCover: [{ required: true, message: "请选择文件", trigger: "blur" }],
      },
      fileList: [],
      // 上传图片地址
      imageUrl: "",
      disabled: false,
      accept: "",
      listType: "",
      tip: "",
      tooken: null,
      upParams: {},
      showViewer: false, // 显示查看器
      url: "",
    };
  },
  computed: {
    isShowVideo() {
      return this.form.type === "视频" && this.form.file.length > 0;
    },
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
      this.upParams.account_id = this.tooken.account_id;
    }
    if (!this.$route.query.id) {
      this.form.type = "文本";
      return;
    }
    this.getData();
  },
  methods: {
    onPreview(url) {
      this.url = url;
      this.showViewer = true;
    },
    // 关闭查看器
    closeViewer() {
      this.url = "";
      this.showViewer = false;
    },
    getData() {
      this.axios
        .post(
          "/crm/CircleMaterial/getMaterialOne",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            id: this.$route.query.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            const data = res.data.data;
            this.form.desc = data.content;
            this.form.linkTitle = data.link_title;
            this.form.link = data.link_url;
            this.form.title = data.title;
            this.form.type = data.type;
            this.form.file = data.url;
            this.form.media_id = data.media_id;
            let fileObj = {
              url: this.form.file,
              name: data.file_name,
            };
            this.fileList.push(fileObj);
            this.setAccept();
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    changeType() {
      this.form.desc = "";
      this.form.file = [];
      this.form.media_id = "";
      this.fileList = [];
      this.form.link = "";
      this.form.linkTitle = "";
      this.form.linkCover = "";
      this.setAccept();
    },
    setAccept() {
      switch (this.form.type) {
        case "图片":
          this.listType = "picture";
          this.tip = "只能上传JPG,PNG格式文件，且不超过2MB";
          this.accept = ".jpg,.png";
          break;
        case "视频":
          this.listType = "text";
          this.tip = "只能上传MP4格式文件，且不超过10MB";
          this.accept = ".mp4";
          this.upParams.type = 2;
          break;
        case "文件":
          this.listType = "text";
          this.tip = "不能超过20MB";
          this.accept = "";
          this.upParams.type = 3;
          break;
        case "链接":
          this.listType = "picture";
          this.tip = "只能上传JPG,PNG格式文件，且不超过2MB";
          this.accept = ".jpg,.png";
          break;
        default:
          break;
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      if (this.form.type === "图片" || this.form.type === "链接") {
        let url = "";
        if (this.$route.query.id) {
          url = file.url;
        } else {
          url = file.response.data.url;
        }
        this.onPreview(url);
      }
    },
    handleExceed(files, fileList) {},
    handleBeforeUpload(file) {
      const size = file.size / 1024 / 1024;
      if (this.form.type === "图片" || this.form.type === "链接") {
        if (size > 2) {
          this.$message({
            message: "上传图片文件过大",
            type: "error",
          });
          return false;
        }
      }
      if (this.form.type === "视频") {
        if (size > 10) {
          this.$message({
            message: "上传视频文件过大",
            type: "error",
          });
          return false;
        }
      }
      if (this.form.type === "文件") {
        if (size > 20) {
          this.$message({
            message: "上传文件过大",
            type: "error",
          });
          return false;
        }
      }
    },
    handleSuccess(response, file, fileList) {
      if (response.code == 0) {
        this.$message({
          message: response.msg,
          type: "error",
        });
        this.form.file = "";
        this.form.media_id = "";
        this.fileList = [];
        return;
      }
      this.$message({
        message: response.msg,
        type: "success",
      });
      this.form.file = response.data.url;
      this.form.media_id = response.data.media_id;
      this.fileList.push(this.form.url);
    },
    handleError(response) {
      this.$message({
        message: response.msg,
        type: "success",
      });
    },
    beforeRemove(file, fileList) {
      this.form.file = [];
      this.fileList = [];
    },
    handleRemove(file) {
      console.log(file);
    },
    handleDownload(file) {
      console.log(file);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    submit() {
      const url = this.$route.query.id ? "editMaterial" : "addMaterial";
      this.axios
        .post(
          `/crm/CircleMaterial/${url}`,
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            id: this.$route.query.id,
            type: this.form.type,
            content: this.form.desc,
            title: this.form.title,
            url: this.form.file,
            media_id: this.form.media_id,
            link_url: this.form.link,
            link_title: this.form.linkTitle,
            describe: this.form.desc,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.$router.go(-1);
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
  },
};
</script>
<style scoped>
.header {
  line-height: 4.0rem;
  border-bottom: .1rem solid rgb(241, 239, 239);
}
.main {
  margin-top: 4.0rem;
}
.form-header,
.form-content {
  /* border: .1rem solid #e9e9e9; */
  padding-top: 22px;
  padding-right: 22px;
  overflow: hidden;
}
.form-content,
.form-footer {
  margin-top: 2.0rem;
}

.el-upload-list__item-thumbnail {
  width: 10.0rem;
  height: 10.0rem;
}
</style>
